import React from "react";
import { LogoAndLanguageSwitcherWrapper, LogoWrapper, Wrapper } from "./styles";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../LanguageSwitcher";
import PBLogoEn from "../icons/PBLogoEn";
import PBLogoKA from "../icons/PBLogoKA";
import Items from "./Items";
import { ROUTES } from "../constants";
import { useLocation } from "react-router-dom";

function Navbar({ items }) {
  const { i18n } = useTranslation();
  const { pathname, search } = useLocation();
  const lastPartOfUrl = pathname.split("/").pop();
  const step = new URLSearchParams(search).get("step");
  const onboardingToken = sessionStorage.getItem("onboardingToken");
  const verificationSteps = [
    "verification-method",
    "otp-verification",
    "confirm-code",
  ];
  const isVerifyIdentity =
    !onboardingToken || !verificationSteps.includes(step);

  const showLanguageSwitcher =
    lastPartOfUrl === ROUTES.identification && isVerifyIdentity;
  const isGeorgian = i18n.language === "ka";

  return (
    <Wrapper>
      <LogoAndLanguageSwitcherWrapper>
        <LogoWrapper>{isGeorgian ? <PBLogoKA /> : <PBLogoEn />}</LogoWrapper>
        {showLanguageSwitcher ? <LanguageSwitcher /> : null}
      </LogoAndLanguageSwitcherWrapper>
      <Items items={items} />
    </Wrapper>
  );
}

export default Navbar;
